export default __webpack_public_path__ + "static/media/banner-4.6e109a42.webp";